// setTimeout(0) fallback covers older Safari where requestIdleCallback is unavailable.
export function runWhenIdle(callback: () => void): () => void {
	if (typeof window === "undefined") {
		return () => {};
	}

	if ("requestIdleCallback" in window) {
		const handle = window.requestIdleCallback(callback);
		return () => window.cancelIdleCallback(handle);
	}

	const handle = setTimeout(callback, 0);
	return () => clearTimeout(handle);
}
